"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.podeReenviarPendenciaOmie = podeReenviarPendenciaOmie;
exports.motivoReenvioPendenciaOmie = motivoReenvioPendenciaOmie;
exports.classificarPendenciaOmie = classificarPendenciaOmie;
exports.filtrarPendenciasOmie = filtrarPendenciasOmie;
function texto(valor, padrao) {
    return typeof valor === 'string' && valor.length > 0 ? valor : padrao;
}
/** A decisão é compartilhada para que nenhuma tela consiga liberar reenvio por conta própria. */
function podeReenviarPendenciaOmie(reenvio) {
    return reenvio.conteudoIdempotico
        && reenvio.aprovacaoValida
        && reenvio.conciliada
        && reenvio.bloqueiosAtuaisLivres
        && reenvio.outboundHabilitado
        && !reenvio.cancelada;
}
function motivoReenvioPendenciaOmie(reenvio) {
    if (!reenvio.outboundHabilitado)
        return 'Envio externo desativado até a governança autorizada.';
    if (reenvio.cancelada)
        return 'Cancelamento pendente de revisão.';
    if (!reenvio.conciliada)
        return 'Resultado incerto exige conciliação antes de repetir a escrita.';
    if (!reenvio.conteudoIdempotico)
        return 'O conteúdo mudou e exige nova revisão.';
    if (!reenvio.aprovacaoValida)
        return 'A aprovação local não é mais válida.';
    if (!reenvio.bloqueiosAtuaisLivres)
        return 'Há bloqueios operacionais pendentes.';
    return 'Reenvio condicionado disponível para processamento autorizado.';
}
/** Sanitiza payload incompleto para trabalho humano local, sem tentar inferir sucesso externo. */
function classificarPendenciaOmie(valor, acesso = {}) {
    if (typeof valor !== 'object' || valor === null || Array.isArray(valor)) {
        return {
            id: '', tipo: 'NOTA_ENTRADA', origem: 'DESCONHECIDA', situacao: 'PAYLOAD_MALFORMADO', criticidade: 'ALTA',
            estado: 'ABERTA', responsavelUserId: null, versao: '', historico: [],
            reenvio: { conteudoIdempotico: false, aprovacaoValida: false, conciliada: false, bloqueiosAtuaisLivres: false, outboundHabilitado: false },
            createdAt: '', updatedAt: '', sanitizada: true,
        };
    }
    const entrada = valor;
    const historicoBruto = Array.isArray(entrada.historico) ? entrada.historico : [];
    const historico = historicoBruto
        .filter((item) => typeof item === 'object' && item !== null && !Array.isArray(item))
        .map((item) => ({ id: texto(item.id, ''), instante: texto(item.instante, ''), evento: texto(item.evento, 'pendencia.desconhecida'), responsavelUserId: typeof item.responsavelUserId === 'string' ? item.responsavelUserId : null }))
        .sort((a, b) => a.instante.localeCompare(b.instante) || a.id.localeCompare(b.id));
    const reenvioBruto = typeof entrada.reenvio === 'object' && entrada.reenvio !== null ? entrada.reenvio : {};
    const reenvio = {
        conteudoIdempotico: reenvioBruto.conteudoIdempotico === true,
        aprovacaoValida: reenvioBruto.aprovacaoValida === true,
        conciliada: reenvioBruto.conciliada === true,
        bloqueiosAtuaisLivres: reenvioBruto.bloqueiosAtuaisLivres === true,
        outboundHabilitado: reenvioBruto.outboundHabilitado === true,
        cancelada: reenvioBruto.cancelada === true,
    };
    const financeiraBruta = typeof entrada.financeira === 'object' && entrada.financeira !== null ? entrada.financeira : null;
    return {
        id: texto(entrada.id, ''),
        tipo: entrada.tipo === 'CONTA_PAGAR' ? 'CONTA_PAGAR' : 'NOTA_ENTRADA',
        origem: entrada.origem === 'COMPRA_PROPRIA' || entrada.origem === 'REMESSA_CLIENTE' ? entrada.origem : 'DESCONHECIDA',
        situacao: ['ENVIADO', 'LOCALIZADO', 'CONCILIADO', 'ERRO', 'RESULTADO_INCERTO', 'PAYLOAD_MALFORMADO'].includes(texto(entrada.situacao, 'PAYLOAD_MALFORMADO')) ? texto(entrada.situacao, 'PAYLOAD_MALFORMADO') : 'PAYLOAD_MALFORMADO',
        criticidade: entrada.criticidade === 'BAIXA' || entrada.criticidade === 'MEDIA' ? entrada.criticidade : 'ALTA',
        estado: texto(entrada.estado, 'ABERTA'), responsavelUserId: typeof entrada.responsavelUserId === 'string' ? entrada.responsavelUserId : null,
        ...(typeof entrada.responsavelNome === 'string' ? { responsavelNome: entrada.responsavelNome } : {}),
        versao: texto(entrada.versao, texto(entrada.updatedAt, '')), historico, reenvio,
        ...(acesso.financeiro && financeiraBruta ? { financeira: { ...(typeof financeiraBruta.valor === 'string' ? { valor: financeiraBruta.valor } : {}), ...(typeof financeiraBruta.vencimento === 'string' ? { vencimento: financeiraBruta.vencimento } : {}) } } : {}),
        createdAt: texto(entrada.createdAt, ''), updatedAt: texto(entrada.updatedAt, ''),
    };
}
function filtrarPendenciasOmie(pendencias, filtros = {}) {
    const ordem = { ALTA: 0, MEDIA: 1, BAIXA: 2 };
    return pendencias.filter((pendencia) => (!filtros.tipo || pendencia.tipo === filtros.tipo)
        && (!filtros.origem || pendencia.origem === filtros.origem)
        && (!filtros.situacao || pendencia.situacao === filtros.situacao)
        && (!filtros.criticidade || pendencia.criticidade === filtros.criticidade)).sort((a, b) => ordem[a.criticidade] - ordem[b.criticidade] || b.updatedAt.localeCompare(a.updatedAt) || a.id.localeCompare(b.id));
}
//# sourceMappingURL=omie-entradas.js.map